var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-5 border-l border-gray-100 text-base md:text-lg"},[_c('MarkdownLinkNavigation',[(_vm.description)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }